<template>
  <div>
    <div class="search flex">
      <span class="tit">病症管理</span>
      <div class="flex">
        <el-button @click="toEdit(0)" size="mini" class="addBtn">添加</el-button>
        <el-input
            suffix-icon="el-icon-search"
            class="addART"
            v-model="search"
            size="mini"
            placeholder="输入关键字搜索"/>
      </div>
    </div>
    <div class="instrument">
      <el-table
          :data="indicationListData.filter(data => !search || data.cnName.toLowerCase().includes(search.toLowerCase()))"
          class="record-table"
          :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
          height="calc(100vh - 265px)"
          max-height="calc(100vh - 265px)"
          row-key="id">
        <el-table-column
            prop="cnName"
            label="中文名" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            prop="enName"
            label="英文名" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="sort" label="排序" align="center">
          <template slot="header">
            <el-button @click="orderOk">排序</el-button>
          </template>
        </el-table-column>
        <el-table-column
            prop="status"
            label="状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0" class="pink common">封禁</span>
            <span v-else class="green common">正常</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="remark"
            label="备注" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            align="right" width="200">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 0" size="mini" class="btn" type="text"
                       @click="changeStatus(scope.row)">启用
            </el-button>
            <el-button v-else size="mini" type="text" class="btn"
                       @click="changeStatus(scope.row)">
              禁用
            </el-button>
            <el-button size="mini" type="text" class="btn" @click="toDelete(scope.row.id)">删除</el-button>
            <el-button @click="toEdit(scope.row.id)" class="btn" size="mini" type="text">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>


  </div>
</template>

<script>
import commonjs from "../../../api/common";
import Sortable from 'sortablejs';

export default {
  name: "indicationList",
  data() {
    return {
      indicationListData: [],//药物列表
      newIndications: [],
      search: ''
    }
  },
  mounted() {
    this.getData();
    this.rowDrop();
  },
  methods: {
    //获得数据
    getData() {
      let that = this;
      this.$ajax.get(commonjs.api.indication.edit.list).then(function (res) {
        if (res.data.status === 'success') {
          that.indicationListData = res.data.list;
        }
      })
    },
    //前往编辑
    toEdit(id) {
      if (id === 0) {
        this.$router.push({name: 'indicationEdit'})
      } else {
        this.$router.push({name: 'indicationEdit', query: {id: id}})
      }
    },
    //删除
    toDelete(id) {
      let that = this;
      this.$confirm('如果只是想暂时下架病症,可禁用', '确认删除?', {
        confirmButtonText: '删除',
        cancelButtonText: '不删了',
        type: 'warning'
      }).then(() => {
        this.$ajax
            .delete(commonjs.api.indication.edit.delete.replace("{indicationId}", id))
            .then(function (res) {
              if (res.data.status === 'success') {
                that.$message.success('操作成功');
                that.getData();
              } else {
                that.$message.error(res.data.message);
              }
            }).catch((err) => {
          console.error(err);
          that.$message.error('操作失败');
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //改变状态
    changeStatus(item) {
      let that = this;
      let msg;
      if (item.status === 0) {
        msg = '启用'
      } else {
        msg = '禁用'
      }
      this.$confirm('是否' + msg + '?', '确认信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax
            .post(commonjs.api.indication.edit.status.replace("{status}/{indicationId}", item.status + "/" + item.id))
            .then(function (res) {
              if (res.data.status === 'success') {
                that.$message.success('操作成功');
                item.status = (item.status + 1) % 2;
              } else {
                that.$message.error(res.data.message);
              }
            }).catch((err) => {
          console.error(err);
          that.$message.error('操作失败');
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      const _this = this
      Sortable.create(tbody, {
        onEnd({newIndex, oldIndex}) {
          const currRow = _this.indicationListData.splice(oldIndex, 1)[0]
          _this.indicationListData.splice(newIndex, 0, currRow)
        }
      })
    },
    //排序
    orderOk() {
      let that = this;
      $(this.indicationListData).each((index, obj) => {
        that.newIndications[index] = obj.id;
      });
      this.$ajax
          .post(commonjs.api.indication.edit.order, this.newIndications)
          .then(function (res) {
            if (res.data.status === 'success') {
              that.$message.success('排序成功');
            } else {
              that.$message.error('操作失败');
            }
            that.getData();
          })
    },
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';

.addART {
  margin-left: 20px
}
</style>
